"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsRecord_1 = __importDefault(require("../../../typeAssertions/valueIsRecord"));
const valueIsArray_1 = __importDefault(require("../../../typeAssertions/valueIsArray"));
const getNumberFromUnknown_1 = __importDefault(require("../../../shared/getNumberFromUnknown"));
const getAdataAndLabelsFromControl = ({ data, propValue, propLabel, labels, }) => {
    try {
        if (propValue && propLabel && (0, valueIsRecord_1.default)(data)) {
            const newLabels = [];
            const newData = [];
            Object.values(data).forEach((item) => {
                if (!(0, valueIsRecord_1.default)(item)) {
                    return;
                }
                const value = (0, getNumberFromUnknown_1.default)(item[propValue]);
                newLabels.push(`${item[propLabel]}`);
                newData.push(value);
            });
            return [newData, newLabels];
        }
        if ((0, valueIsArray_1.default)(data) && (0, valueIsArray_1.default)(labels)) {
            const newData = data.map((val) => {
                try {
                    return (0, getNumberFromUnknown_1.default)(val);
                }
                catch (_a) {
                    return 0;
                }
            });
            return [newData, labels];
        }
    }
    catch (_a) {
        return [undefined, undefined];
    }
    return [undefined, undefined];
};
exports.default = getAdataAndLabelsFromControl;
